import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthScreen, createAuthApi } from '../features/auth'
import { api } from '../api/client'
import { useSession } from '../app/session'
import { returnPath } from '../app/loginReturn'
import { IconSprite } from '../ui/Icon'

export function LoginPage() {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { signIn, telegram } = useSession()
  const authApi = useMemo(() => createAuthApi(api), [])

  // Вход живёт вне каркаса (без шапки и вкладок), но колонка и значки у него
  // те же: без .shell экран сжимался по содержимому, без спрайта пустела стрелка.
  return (
    <main className="shell shell-bare">
      <IconSprite />
      {/* Ответ мини-аппа может прийти, когда экран уже открыт: новый шаг — новый экран. */}
      <AuthScreen
        key={telegram?.kind ?? 'site'}
        api={authApi}
        telegram={telegram}
        onAuthenticated={(tokens) => {
          signIn(tokens)
          // Пришли с закрытого экрана (`?next=`) — туда и возвращаемся.
          void navigate(returnPath(search), { replace: true })
        }}
      />
    </main>
  )
}
